export const activeSuccess = ({ companyName, seatno }, _this) => {
  const h = _this.$createElement;
  _this.$msgbox({
    title: '报名成功',
    message: h('div', null, [
      h('p', null, '已报名成功，请等待运营审核 '),
      h('p', null, '企业名称: ' + companyName),
      seatno ? h('p', null, '摊位编号: ' + seatno + '号') : null
    ]),
    showCancelButton: false,
    confirmButtonText: '好的，我知道了！',
    // beforeClose: (action, instance, done) => {
    //   if (action === 'confirm') {
    //     instance.confirmButtonLoading = true;
    //     instance.confirmButtonText = '执行中...';
    //     setTimeout(() => {
    //       done();
    //       setTimeout(() => {
    //         instance.confirmButtonLoading = false;
    //       }, 300);
    //     }, 3000);
    //   } else {
    //     done();
    //   }
    // }
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/msgbox.js